import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { QueueStatistic } from '@blade-sxp/monitor/components/monitor-management/task';
import { postTask, getTaskDetail, putTargetsDetail } from '@blade-sxp/monitor/api/queue/task';
import { postDevicesGroupTree } from '@blade-sxp/monitor/api/device-management/control';
import EquipmentSelection from './components/equipment-selection/index.vue';
let default_1 = class extends Vue {
    taskType = 9;
    regionDetail = [];
    crossLineDetail = [];
    regionDrawData = [];
    crossLineDrawData = [];
    operateType = 0; // 0创建，1编辑，2查看
    groupTree = [];
    groupTreeFilter = [];
    taskDetail = {};
    taskTypeDetail = {};
    loading = false;
    form = { taskName: '', taskDesc: '', taskType: '9', configObjects: [], taskId: 0 };
    accountRules = {
        taskName: [{ required: true, message: this.$t('task.taskName'), trigger: blur }],
        taskType: [
            {
                required: true,
                message: this.$t('task.taskType'),
                trigger: blur,
                validator: (rule, value, callback) => {
                    callback();
                },
            },
        ],
        selectQueueRegion: [
            {
                required: true,
                trigger: blur,
                validator: (rule, value, callback) => {
                    callback();
                },
            },
        ],
        selectQueueRegionExit: [
            {
                required: true,
                trigger: blur,
                validator: (rule, value, callback) => {
                    callback();
                },
            },
        ],
    };
    postDevicesGroupTree() {
        postDevicesGroupTree().then(resp => {
            this.groupTree = this.filterTree(resp.data.data.trees);
        });
    }
    filterTree(deviceGroup, arr = []) {
        if (!deviceGroup || !deviceGroup.length)
            return [];
        for (let device of deviceGroup) {
            const node = { ...device, children: [] };
            if (device.nodeType === 'DEVICE_GROUP') {
                this.filterTree(device.children, node.children);
                arr.push(node);
            }
            else if (device.nodeType === 'DEVICE' && device.canPlay)
                arr.push(node);
        }
        return arr;
    }
    handleCancel() {
        const path = '/application/queue/taskManagement';
        const activeName = 'second';
        this.$router.push({ path, query: { activeName } });
    }
    onRadioChange(value) { }
    getLen(str) {
        let len = 0;
        for (let i = 0; i < str.length; i++) {
            let c = str.charCodeAt(i);
            // 单字节加1
            if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
                len++;
            }
            else {
                len += 2;
            }
        }
        return len;
    }
    taskNameChange() {
        if (this.getLen(this.form.taskName) > 128) {
            this.$message.error(this.$t('taskNameError').toString());
        }
    }
    request() {
        this.loading = true;
        this.form.configObjects = [];
        this.processRegion();
        this.processCrossline();
        this.form.extraInfo = { point: this.$refs.queueStatistic.formData.location };
        const taskId = this.$route.params.id;
        const request = taskId ? putTargetsDetail : postTask;
        this.form.taskId = taskId || undefined;
        request(this.form)
            .then(res => {
            const path = '/queue/taskManagement';
            const activeName = 'second';
            if (res?.data?.code === 0) {
                if (taskId) {
                    this.$message.success(this.$t('editSuccess').toString());
                }
                else {
                    this.$message.success(this.$t('createSuccess').toString());
                }
                this.$router.push({ path, query: { activeName } });
            }
            else {
                this.$message.error(this.$t('fail').toString());
                this.loading = false;
            }
        })
            .catch(err => {
            this.$message.error({ message: err, type: 'error' });
            this.loading = false;
        });
    }
    handleSubmit() {
        this.$refs['accountForm'].validate((valid) => {
            if (valid) {
                if (this.getLen(this.form.taskName) > 128) {
                    this.$message.error(this.$t('taskNameError').toString());
                    return;
                }
                if (this.getLen(this.form.taskDesc) > 256) {
                    this.$message.error(this.$t('taskDesError').toString());
                    return;
                }
                this.request();
            }
            else {
                this.$message.error(this.$t('paramError').toString());
                return false;
            }
        });
    }
    onRegionDataChage(data) {
        this.regionDrawData = data;
        this.groupTreeFilter = this.filterGroupTree(this.groupTree, (node) => {
            return this.regionDrawData.findIndex(item => `DEVICE#${item.id}` === `${node.nodeType}#${node.treeId}`) !== -1;
        });
    }
    filterGroupTree(groupTree, predicate) {
        const getNodes = (last, curNode) => {
            if (predicate(curNode)) {
                last.push(curNode);
                return last;
            }
            if (Array.isArray(curNode.children)) {
                const children = curNode.children.reduce(getNodes, []);
                if (children.length)
                    last.push({ ...curNode, children });
            }
            return last;
        };
        return groupTree.reduce(getNodes, []);
    }
    onCrossLineDataChange(data) {
        this.crossLineDrawData = data;
    }
    processData(taskType, drawData) {
        const form = this.form;
        const nameProp = taskType === 2 ? 'crowdStatisticConfig' : 'regionStatisticConfigWithRois';
        drawData.map((resp) => {
            if (resp && resp.canPlay) {
                const [ploygon, drawerData] = this.processPolygon(resp, taskType);
                const [calib, drawerData1] = this.processCalibration(resp);
                const drawer = { allDrawer: drawerData, allDrawer1: drawerData1 };
                const configObj = {
                    deviceId: resp.id,
                    frontEndData: JSON.stringify(drawer),
                    [nameProp]: { ...ploygon },
                    labelPersons: calib,
                };
                form.configObjects.push(configObj);
            }
        });
    }
    processRegion() {
        this.processData(10, this.regionDrawData);
    }
    processCrossline() {
        this.processData(2, this.crossLineDrawData);
    }
    processPolygon(info, taskType) {
        const data = info.allDrawer;
        const roiList = [];
        data.map((graph, index) => {
            let vertices = [];
            let lines = [];
            let directions = [];
            if (graph.type === 'line' || graph.type === 'lines') {
                lines = [...graph.vertices];
                if (graph.direction) {
                    const { vertical, choose } = graph.direction;
                    const reVer = [...vertical].reverse();
                    if (choose === 0)
                        directions = [...reVer];
                    else if (choose === 1)
                        directions = [...vertical];
                }
            }
            else if (graph.type === 'polygon') {
                vertices = [...graph.vertices];
            }
            else if (graph.type === 'rect') {
                const rect = graph.vertices;
                vertices.push({ ...rect[0] });
                vertices.push({ x: rect[1].x, y: rect[0].y });
                vertices.push({ ...rect[1] });
                vertices.push({ x: rect[0].x, y: rect[1].y });
            }
            let retData = { roiId: index + 1, vertices };
            if (taskType === 2) {
                const modelSelection = info.modelSelection;
                retData = { roiId: index + 1, crossLine: lines, directions: directions, modelSelection };
            }
            roiList.push(retData);
        });
        if (taskType === 2)
            return [roiList[0], data];
        return [{ roiList }, data];
    }
    processCalibration(info) {
        let labelPersons = [];
        const data = info.allDrawer1;
        data.map((graph) => {
            if (graph.type === 'rect') {
                const rect = [...graph.vertices];
                const ystart = rect[0].y > rect[1].y ? rect[1].y : rect[0].y;
                const yEnd = rect[0].y < rect[1].y ? rect[1].y : rect[0].y;
                labelPersons.push({ x: ystart, y: yEnd });
            }
        });
        return [labelPersons, data];
    }
    /**
     *@Description: 获取任务详情
     *@Date: 2020-09-17 10:31:18
     */
    getTaskDetail() {
        let id = this.$route.params.id;
        if (!id)
            return;
        getTaskDetail(id)
            .then(taskDetail => {
            const taskDetailMessage = taskDetail.data.data;
            this.form.taskName = taskDetailMessage.taskName;
            this.form.taskDesc = taskDetailMessage.taskDesc;
            this.taskDetail = taskDetailMessage;
            this.taskType = taskDetailMessage.taskType;
            this.classicSubTasks(taskDetailMessage.baseTaskVOS);
            const taskTypeData = JSON.parse(taskDetailMessage?.configJson || '{}');
            this.taskTypeDetial(taskTypeData);
        })
            .catch(() => {
            this.$message.error(`${this.$t('common.serverError')}`);
        });
    }
    classicSubTasks(subTasks) {
        for (const subTask of subTasks) {
            const { taskType } = subTask;
            if (taskType === 2) {
                this.crossLineDetail.push(subTask);
            }
            else if (taskType === 10) {
                this.regionDetail.push(subTask);
            }
        }
    }
    taskTypeDetial(data) {
        // const { roi, roiId, directions, crossLine, queueLines, modelSelection } = data || {};
        this.taskTypeDetail = { location: this.taskDetail?.extraInfo?.point };
    }
    created() {
        const id = this.$route.params.id;
        if (id)
            this.operateType = 1;
        this.addValidRules();
    }
    getSubRef() {
        const ref = this.$refs.queueStatistic;
        return ref;
    }
    addValidRules() {
        const nameList = [{ field: 'location', key: 'location', required: true }];
        const isEmpty = (value) => value === undefined || value === '' || value === null;
        const validator = (options) => {
            const { field, key, required, type, min = -Infinity, max = Infinity } = options;
            return (rule, value, callback) => {
                const ref = this.getSubRef();
                // const fieldInfo = nameList.find((item) => item.field === field);
                if (!ref)
                    return callback();
                const vaildData = ref?.formData[key || ''];
                if (type === 'array') {
                    if (!required || vaildData.length > 0)
                        return callback();
                }
                else if (type === 'number') {
                    if (isEmpty(vaildData) && !required)
                        return callback();
                    if (!isNaN(vaildData)) {
                        const num = Number(vaildData);
                        if (num >= min && num <= max)
                            return callback();
                    }
                    return callback(this.$t('numberRangeError', [min, max]));
                }
                else if (type === 'integer') {
                    if (isEmpty(vaildData) && !required)
                        return callback();
                    if (!isNaN(vaildData)) {
                        const num = Number(vaildData);
                        if (Number.isInteger(num) && num >= min && num <= max)
                            return callback();
                    }
                    return callback(this.$t('integerRangeError', [min, max]));
                }
                else {
                    if ((isEmpty(vaildData) && !required) || !isEmpty(vaildData))
                        return callback();
                }
                return callback(new Error(this.$t(`task.${field}`).toString()));
            };
        };
        nameList.forEach(item => {
            this.accountRules[item.field] = [{ required: item.required, trigger: blur, validator: validator(item) }];
        });
    }
    mounted() {
        this.postDevicesGroupTree();
        this.getTaskDetail();
    }
};
default_1 = __decorate([
    Component({
        name: 'CreateTask',
        components: {
            EquipmentSelection,
            // AuthItem,
            QueueStatistic,
        },
        i18n: {
            messages: {
                'en-us': {
                    editSuccess: 'edit success',
                    createSuccess: 'create success',
                    fail: 'create Fail',
                    region: 'Set the direction of crowd departure',
                    body: 'Body Tag',
                    deviceLoadError: 'Device Load Error',
                    getTaskDetailFail: 'Get Task Detail Failed',
                    forever: 'Unlimited',
                    labWarn: 'at least draw 3 items',
                    arrowWarn: 'need draw one arrow line',
                    ploygonWarn: 'only one polygon needed',
                    paramError: 'Input Error, Please Check Input Parameters',
                    integerRangeError: 'Please Input Integer Of {0}~{1}',
                    numberRangeError: 'Please Input Number Of {0}~{1}',
                    taskNameError: 'The task name cannot exceed 128 characters',
                    taskDesError: 'The task description cannot exceed 256 characters',
                    onlySupports: 'Currently only supports adding one device',
                    submitTip: 'When the face control task is created, the face capture (face attribute) task of the selected device will be created automatically (single device will not be created repeatedly), please be aware!',
                    taskType: 'Task Type',
                    queueStatistic: 'Queued People Counting',
                    selectQueueRegion: 'Select Queue Area:',
                    selectQueueRegionExit: 'Select Queuing Area Exit:',
                    maxSelectQueueRegion: 'Support up to {0} regional devices',
                },
                zh: {
                    editSuccess: '编辑成功',
                    createSuccess: '创建成功',
                    region: '设置人群离开方向',
                    fail: '创建失败',
                    body: '手动人体标定',
                    deviceLoadError: '设备加载异常',
                    getTaskDetailFail: '获取任务详情异常',
                    forever: '无限期',
                    labWarn: '至少需要绘制3个图形',
                    arrowWarn: '需要绘制一个方向',
                    ploygonWarn: '最多绘制一个多边形',
                    paramError: '输入错误, 请检查输入参数',
                    integerRangeError: '请填写{0}~{1}的整数',
                    numberRangeError: '请填写{0}~{1}的数字',
                    taskNameError: '任务名称不能超过128个字符',
                    taskDesError: '任务描述不能超过256个字符',
                    onlySupports: '目前只支持添加一个设备',
                    submitTip: '创建该人脸布控任务时，会自动同步创建所选设备的人脸抓拍（人脸属性）任务（单个设备不重复创建），请知悉！',
                    taskType: '任务类型',
                    queueStatistic: '排队统计',
                    selectQueueRegion: '选择排队区域：',
                    selectQueueRegionExit: '选择排队区域出口：',
                    maxSelectQueueRegion: '最多支持{0}个区域摄像头',
                },
            },
        },
    })
], default_1);
export default default_1;
